export const currentBasketInitialData = {
  value: '5.97', //default subtotal value for the empty cart case
  value_excl_shipping: 0,
  quantity_total: 0,
};
